import BaseModal from "@components/modal/BaseModal";
import ModalForm from "@components/modal/ModalForm";

export default function FormModal(props) {
  const {
    mx,
    data,
    config,
    onSubmitSuccess,
  } = props;

  /**************************************************************************************************/

  if (!config) return null;

  return (
    <BaseModal
      mx={mx}
      width={config.width}
    >
      <ModalForm
        config={config}
        data={data}
        mx={mx}
        onSubmitSuccess={onSubmitSuccess}
      />
    </BaseModal>
  );
}
